module.exports = function (_ref) {
  var thoughts = _ref.thoughts,
      eyes = _ref.eyes,
      eye = _ref.eye,
      tongue = _ref.tongue;
  return "\n        ".concat(thoughts, "   ^__^\n         ").concat(thoughts, "  (").concat(eyes, ")\\_______\n            (__)\\       )\\/\\\n             ").concat(tongue, " ||----w |\n                ||     ||\n");
};